module.exports = __webpack_public_path__ + "static/media/newword.29d0e303.png";